import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Portal from 'modules/core/components/Portal'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import FileViewer from './FileViewer'
import PictureInfo from './PictureInfo'
import './index.styles.css'
interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
  onClose: () => void
}

const ClockPicturePreview = ({ clockPicture, employeeFullName, onClose }: Props) => {
  return (
    <Portal onClose={onClose}>
      <div className={'ClockPicturePreview_modal'}>
        <div className={'ClockPicturePreview_box'}>
          <div className={'ClockPicturePreview_body'}>
            <div className={'ClockPicturePreview_file'}>
              <Box flexGrow alignItems="center" justifyContent="center">
                <FileViewer clockPicture={clockPicture} />
              </Box>
            </div>
            <Box>
              <PictureInfo
                clockPicture={clockPicture}
                employeeFullName={employeeFullName}
                onClose={onClose}
              />
            </Box>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default observer(ClockPicturePreview)
